import {
  RouteRecordRaw, RouterOptions,
  createRouter, createWebHistory, createWebHashHistory
} from 'vue-router';

import { RouterEnum } from '@interface/public';
import Config from '@constant/config';

export const RouterList: RouteRecordRaw[] = [ // 路由列表
  {
    path: RouterEnum.Root,
    redirect: () => {
      let route = RouterEnum.OverseasENHome;
      
      switch ($Store.Overseas().getLanguage()) {
        case $Enum.LanguageEnum.ZH:
        case $Enum.LanguageEnum.ZH_CN:
        case $Enum.LanguageEnum.ZH_HK:
        case $Enum.LanguageEnum.ZH_TW:
          route = $Config.Template.default;
          break;
        case $Enum.LanguageEnum.EN:
        default:
          route = $Enum.RouterEnum.OverseasENHome;
          break;
      }
      return route;
    },
    name: '根'
  },
  {
    path: RouterEnum.Index,
    redirect: Config.Template.default,
    name: '主页'
  },
  {
    path: RouterEnum.Page,
    redirect: Config.Template.default,
    name: '页面',
    component: () => import('@template/page/index.vue'),
    children: [
      {
        path: RouterEnum.Home,
        name: '首页',
        component: () => import('@template/page/home/home.vue')
      },
      {
        path: RouterEnum.Database,
        name: '资料库',
        component: () => import('@template/page/database/database.vue')
      },
      {
        path: RouterEnum.Consult,
        name: '咨询服务',
        component: () => import('@template/page/consult/consult.vue')
      },
      {
        path: RouterEnum.About,
        name: '关于我们',
        component: () => import('@template/page/about/about.vue')
      },
      {
        path: RouterEnum.Community,
        name: '开源社区',
        component: () => import('@template/page/community/community.vue')
      },
      
      //----- 产品 Start -----//
      {
        path: RouterEnum.ProductSchedulX,
        name: '产品-SchedulX',
        component: () => import('@template/page/productSchedulX/product.vue')
      },
      // {
      //     path: RouterEnum.ProductSchedulXSaaS,
      //     name: '产品-SchedulXSaaS',
      //     component: () => import('@template/page/productSchedulXSaaS/product.vue')
      // },
      {
        path: RouterEnum.ProductCostPilot,
        name: '产品-CostPilot',
        component: () => import('@template/page/productCostPilot/product.vue')
      },
      {
        path: RouterEnum.ProductInfraPilot,
        name: '产品-InfraPilot',
        component: () => import('@template/page/productInfraPilot/product.vue')
      },
      {
        path: RouterEnum.ProductAIPilot,
        name: '产品-AIPilot',
        component: () => import('@template/page/productAIPilot/product.vue')
      },
      {
        path: RouterEnum.ProductAidigitalHuman,
        name: '产品-AidigitalHuman',
        component: () => import('@template/page/productAidigitalHuman/product.vue')
      },
      {
        path: RouterEnum.ProductPrivateAidigitalHuman,
        name: '产品-PrivateAidigitalHuman',
        component: () => import('@template/page/productPrivateAidigitalHuman/product.vue')
      },
      //----- 产品 End -----//
      
      //----- 解决方案 Start -----//
      {
        path: RouterEnum.PlanOperation,
        name: '解决方案-智能运维',
        component: () => import('@template/page/planOperation/plan.vue')
      },
      {
        path: RouterEnum.PlanTrusteeship,
        name: '解决方案-运维托管',
        component: () => import('_Project/application/template/page/planTrusteeship/planTrusteeship.vue')
      },
      {
        path: RouterEnum.PlanCost,
        name: '解决方案-成本优化',
        component: () => import('@template/page/planCost/plan.vue')
      },
      {
        path: RouterEnum.PlanStable,
        name: '解决方案-高峰流量应对',
        component: () => import('@template/page/planStable/plan.vue')
      },
      {
        path: RouterEnum.PlanMigrate,
        name: '解决方案-东数西算',
        component: () => import('@template/page/planMigrate/plan.vue')
      },
      {
        path: RouterEnum.PlanActive,
        name: '解决方案-多活部署',
        component: () => import('@template/page/planActive/plan.vue')
      },
      //----- 解决方案 End -----//
      
      //----- 新闻 Start -----//
      {
        path: RouterEnum.News,
        name: '新闻',
        component: () => import('@template/page/news/news.vue')
      },
      {
        path: RouterEnum.NewsDetail,
        name: '新闻-详情',
        component: () => import('@template/page/news/newsDetail.vue')
      },
      //----- 新闻 End -----//
      
      {
        path: RouterEnum.License,
        name: '许可证',
        component: () => import('@template/page/license/license.vue')
      }
    ]
  },
  {
    path: RouterEnum.Book,
    redirect: Config.Template.default,
    name: '白皮书',
    component: () => import('@template/book/index.vue'),
    children: [
      {
        path: RouterEnum.BookIndustry,
        name: '白皮书-Serverless行业',
        component: () => import('@template/book/industry/industry.vue')
      },
      {
        path: RouterEnum.BookCostOptimization,
        name: '白皮书-IT成本优化',
        component: () => import('@template/book/costOptimization/costOptimization.vue')
      },
      {
        path: RouterEnum.BookDevOps,
        name: '白皮书-运维方案',
        component: () => import('@template/book/devOps/devOps.vue')
      }
    ]
  },
  {
    path: RouterEnum.OverseasEN,
    redirect: RouterEnum.OverseasENHome,
    name: '海外-英文版',
    component: () => import('@template/overseas/index.vue'),
    children: [
      {
        path: RouterEnum.OverseasENHome,
        name: '海外-英文版-首页',
        component: () => import('@template/overseas/home/home.vue')
      }
    ]
  },
  {
    path: RouterEnum.All,
    redirect: Config.Template.default,
    name: '默认'
  }
];

/**
 * 路由
 */
export default createRouter({
  history: $ENV.isProduction
    ? createWebHistory('/')
    : createWebHashHistory('/'),
  routes: RouterList
} as RouterOptions);